// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wkv1jPROc2zzNo {
  margin: 0 12px 8px;
  padding: 8px;
  border-radius: 4px;
  background-color: var(--ds-background-information, #e9f2ff);
  color: var(--ds-text-subtle, #44546f);
}
.g0hoCdu5Z5YQNC {
  color: var(--ds-text-disabled, #091e424f);
  pointer-events: none;
}
.B4JH_aj15GYQWO {
  color: var(--ds-text-danger, #ae2a19);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardVisibilityDescription": `Wkv1jPROc2zzNo`,
	"boardVisibilityOptionDisabled": `g0hoCdu5Z5YQNC`,
	"boardVisibilityDisabledMessaging": `B4JH_aj15GYQWO`
};
export default ___CSS_LOADER_EXPORT___;
